var _defs, _rect, _rect2, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobomindLogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 178.32 414.49 91.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #737373;\n      }\n\n      .cls-3 {\n        fill: #545454;\n      }\n\n      .cls-4 {\n        fill: #0092d0;\n      }\n\n      .cls-5 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-6 {\n        fill: #00adef;\n      }\n\n      .cls-7 {\n        clip-path: url(#clip-path-2);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-45.44 -47.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 203.19,
    y: 225.81,
    width: 20.09,
    height: 37.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-45.44 -47.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 99.27,
    y: 225.81,
    width: 20.09,
    height: 37.33
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.84,
    y: 24.89,
    width: 20,
    height: 27.49
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.12,
    width: 18.67,
    height: 26.51
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.82,259.38",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201.82,259.38",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.94,254.71a31.7,31.7,0,0,0,5.27-.35,7.7,7.7,0,0,0,3.3-1.25,4.54,4.54,0,0,0,1.68-2.4,12.68,12.68,0,0,0,.46-3.71v-1.08a13.72,13.72,0,0,0-.44-3.85,3.73,3.73,0,0,0-1.66-2.27A8.91,8.91,0,0,0,79,238.71a51,51,0,0,0-6-.29H50.86v16.29ZM90,274.36H84.59v-4.5a32.72,32.72,0,0,0-.38-5.54,5.5,5.5,0,0,0-1.64-3.27,7,7,0,0,0-3.77-1.59,46.41,46.41,0,0,0-6.79-.39H50.86v15.29H45.44V234.07H74.65a47.22,47.22,0,0,1,7.65.5,11.22,11.22,0,0,1,4.75,1.75,6.36,6.36,0,0,1,2.41,3.35,17.42,17.42,0,0,1,.69,5.33v1.5a18.26,18.26,0,0,1-.46,4.5,7.44,7.44,0,0,1-1.43,3,6.18,6.18,0,0,1-2.36,1.79,14.7,14.7,0,0,1-3.25,1v.07a16.51,16.51,0,0,1,3.56,1,5.57,5.57,0,0,1,2.3,1.75,7.06,7.06,0,0,1,1.16,3,27.61,27.61,0,0,1,.34,4.71Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.94,274.36V234.07h29.15a42.88,42.88,0,0,1,7,.48,11,11,0,0,1,4.5,1.6,5.88,5.88,0,0,1,2.35,3.06,16.9,16.9,0,0,1,.19,8.86,7.79,7.79,0,0,1-1.39,2.73,6.75,6.75,0,0,1-2.11,1.66,8.56,8.56,0,0,1-2.64.82,9,9,0,0,1,6.08,2.58q2,2.2,2,7.14a17.68,17.68,0,0,1-.73,5.48A7.09,7.09,0,0,1,192,272a10.22,10.22,0,0,1-4.45,1.86,38.78,38.78,0,0,1-7,.52ZM179.71,270a34.25,34.25,0,0,0,5.19-.31,6.87,6.87,0,0,0,3-1.14,4,4,0,0,0,1.44-2.23,13.9,13.9,0,0,0,.37-3.52,13.56,13.56,0,0,0-.39-3.55,4.19,4.19,0,0,0-1.4-2.18A6,6,0,0,0,185.3,256a22.25,22.25,0,0,0-4.07-.31H155.36V270Zm.65-18.58q4.5,0,6.21-1.42c1.15-.95,1.73-2.67,1.73-5.14a11.13,11.13,0,0,0-.4-3.25,3.92,3.92,0,0,0-1.39-2,6.26,6.26,0,0,0-2.75-1,28.15,28.15,0,0,0-4.55-.29H155.36v13.14Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.51,274.36h-5.36v-35.5H310l-22.92,35.5h-4.5l-23.08-35.5h-.21v35.5h-5.36V234.07h8.57l22.35,34.58h.23l22.06-34.58h8.36Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M334.35,274.36h-5.41V234.07h5.41Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.94,274.36h-8.59L353.5,238.71h-.35v35.65h-5.36V234.07h8.56l34.94,35.58h.21V234.07h5.44Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M459.92,254.78q0,4.23-.29,7.33a17.11,17.11,0,0,1-1.21,5.29,9.14,9.14,0,0,1-2.56,3.54,11.62,11.62,0,0,1-4.38,2.11,34.52,34.52,0,0,1-6.6,1c-2.58.18-5.69.27-9.31.27H410.36V234.07h25.21a109.27,109.27,0,0,1,12.89.6,14.62,14.62,0,0,1,7.36,2.65,9.74,9.74,0,0,1,3.31,5.89,54.19,54.19,0,0,1,.79,10.44Zm-24.79,15a93.56,93.56,0,0,0,10.58-.46,11.61,11.61,0,0,0,5.77-2,7,7,0,0,0,2.44-4.59,53.1,53.1,0,0,0,.5-8.18v-.71a54,54,0,0,0-.5-8.31,7.11,7.11,0,0,0-2.46-4.61,11.06,11.06,0,0,0-5.83-2q-3.86-.39-10.5-.39H415.78V269.8Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.4,311.16a6,6,0,0,1-.82,3.08,6.61,6.61,0,0,1-2.25,2.3,6,6,0,0,1-3.18.87h-9.39a6,6,0,0,1-3.09-.82,6.44,6.44,0,0,1-2.26-2.26,6.56,6.56,0,0,1-.9-3.17h3.13a3.14,3.14,0,0,0,3.12,3.12h9.39a3.14,3.14,0,0,0,3.13-3.12,3.14,3.14,0,0,0-3.13-3.13h-9.39a6.12,6.12,0,0,1-3.09-.83,6.28,6.28,0,0,1-2.3-2.25,6,6,0,0,1-.86-3.18,5.9,5.9,0,0,1,.83-3.07,6.47,6.47,0,0,1,2.25-2.31,6,6,0,0,1,3.17-.87h9.39a5.87,5.87,0,0,1,3.08.84,6.72,6.72,0,0,1,2.27,2.26,6.08,6.08,0,0,1,.9,3.15h-3.12a3.14,3.14,0,0,0-3.13-3.12h-9.39a3.12,3.12,0,0,0-2.2,5.33,3,3,0,0,0,2.2.92h9.39a6,6,0,0,1,3.08.85,6.69,6.69,0,0,1,2.3,2.25A5.89,5.89,0,0,1,151.4,311.16Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M184.14,300.21l-9.38,10.32v6.88h-3.13v-6.88l-9.38-10.32v-4.69h3.13v3.41l7.82,8.6,7.82-8.6v-3.41h3.12Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216.88,311.16a6,6,0,0,1-.82,3.08,6.61,6.61,0,0,1-2.25,2.3,6,6,0,0,1-3.18.87h-9.39a6,6,0,0,1-3.09-.82,6.44,6.44,0,0,1-2.26-2.26,6.56,6.56,0,0,1-.9-3.17h3.13a3,3,0,0,0,.92,2.2,3,3,0,0,0,2.2.92h9.39a3.14,3.14,0,0,0,3.13-3.12,3.14,3.14,0,0,0-3.13-3.13h-9.39a6.12,6.12,0,0,1-3.09-.83,6.28,6.28,0,0,1-2.3-2.25,6,6,0,0,1-.86-3.18,5.9,5.9,0,0,1,.83-3.07,6.47,6.47,0,0,1,2.25-2.31,6,6,0,0,1,3.17-.87h9.39a5.87,5.87,0,0,1,3.08.84,6.72,6.72,0,0,1,2.27,2.26,6.08,6.08,0,0,1,.9,3.15h-3.12a3.14,3.14,0,0,0-3.13-3.12h-9.39A3.12,3.12,0,0,0,199,304a3,3,0,0,0,2.2.92h9.39a6,6,0,0,1,3.08.85A6.61,6.61,0,0,1,216,308,5.89,5.89,0,0,1,216.88,311.16Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M249,298.65h-9.39v18.76h-3.12V298.65H227.1v-3.13H249Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M262.66,298.65v6.25H278.3V308H262.66v6.25h18.77v3.13h-21.9V295.52h21.9v3.13Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M305.41,314.66,296,301.12v16.29H292.9V295.52H296l9.38,13.54,9.38-13.54h3.13v21.89h-3.13V301.12Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M351.6,311.16a6.06,6.06,0,0,1-.83,3.08,6.44,6.44,0,0,1-2.25,2.3,6,6,0,0,1-3.18.87H336a6,6,0,0,1-3.1-.82,6.33,6.33,0,0,1-2.25-2.26,6.46,6.46,0,0,1-.91-3.17h3.13a3.14,3.14,0,0,0,3.13,3.12h9.38a3.14,3.14,0,0,0,3.13-3.12,3.14,3.14,0,0,0-3.13-3.13H336a6.13,6.13,0,0,1-3.1-.83,6.28,6.28,0,0,1-2.3-2.25,6.07,6.07,0,0,1-.86-3.18,6,6,0,0,1,.83-3.07,6.55,6.55,0,0,1,2.25-2.31,6,6,0,0,1,3.18-.87h9.38a5.82,5.82,0,0,1,3.08.84,6.63,6.63,0,0,1,2.27,2.26,6.19,6.19,0,0,1,.91,3.15h-3.13a3.14,3.14,0,0,0-3.13-3.12H336a3.12,3.12,0,0,0-2.21,5.33,3,3,0,0,0,2.21.92h9.38a6,6,0,0,1,3.08.85,6.61,6.61,0,0,1,2.3,2.25A5.9,5.9,0,0,1,351.6,311.16Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.32,260.67",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.2,261.84,221,279.61V263.29l-9.61-9.6Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M203.2,261.85l19.06-19.07V226.46L203.2,245.53Z",
    transform: "translate(-45.44 -47.81)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.6,252.06,225.69,263v16.32l19.07-19.07V243.9Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227,226.13v16.32l9.62,9.61,8.16-8.16Z",
    transform: "translate(-45.44 -47.81)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.4,260.67",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.27,261.84,117,279.61V263.29l-9.61-9.6Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.27,261.85l19.07-19.07V226.46L99.27,245.53Z",
    transform: "translate(-45.44 -47.81)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M132.67,252.06,121.76,263v16.32l19.07-19.07V243.9Z",
    transform: "translate(-45.44 -47.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123.06,226.13v16.32l9.61,9.61,8.16-8.16Z",
    transform: "translate(-45.44 -47.81)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobomindLogo);
export default __webpack_public_path__ + "static/media/robomind-logo.cd0a8250651ec73e0dc69cfb60ff3585.svg";
export { ForwardRef as ReactComponent };